/** Celda sin dato (design system, tablas). */
export const EMPTY_VALUE = '—'

/** `yyyy-MM-dd` (o `yyyy-MM-ddTHH:mm:ss`) a `dd/MM/yyyy`, sin pasar por `Date` para no depender de la zona horaria. */
export function formatIsoDay(iso: string): string {
  const [year, month, day] = iso.slice(0, 10).split('-')
  return `${day}/${month}/${year}`
}

/** `yyyy-MM-ddTHH:mm:ss` a `dd/MM/yyyy HH:mm`. */
export function formatIsoDateTime(iso: string): string {
  return `${formatIsoDay(iso)} ${iso.slice(11, 16)}`
}

/** Fecha, o fecha y hora si el valor la trae (`yyyy-MM-dd` o `yyyy-MM-ddTHH:mm:ss`). */
export function formatIsoMoment(iso: string): string {
  return iso.length > 10 ? formatIsoDateTime(iso) : formatIsoDay(iso)
}

/** Texto o "—" si viene vacío. */
export function textOrDash(value: string | null): string {
  return value && value.trim() !== '' ? value : EMPTY_VALUE
}
